<script setup>
import {computed, defineEmits, defineProps, ref} from "vue";
import {couponConf} from "@/utils/config";
import store from "@/store";
import SendSmsComponents from "@/components/login/SendSmsComponents.vue";
import RealName from "@/components/login/RealName.vue";
import {ElMessage} from "element-plus";
import axiosApi from "@/utils/axiosApi";
import router from "@/router";

const props = defineProps({
  couponLst: {
    type: Array,
    default: () => {
      return [];
    },
  },
  account: {
    type: Object,
    default: () => {
      return {};
    },
  },
  type: {
    type: Object,
    default: () => {
      return couponConf["atl-scal"];
    }
  }
});

const coupon = computed(() => {
  return props.couponLst?.[0]?.data || []
})
const order_from = computed(() => store.state.orderFrom)
const emit = defineEmits(['login'])
const rechargeTool = ref("01")
const showPayLoading = ref(false)
const product = ref({})
const mobile = ref("")
const num = ref(1)
const sendSms = ref(false)
const realname = ref(false)
const loading = ref(false)
const payment = () => {
  if (!/^1[3-9]\d{9}$/.test(mobile.value)) {
    return ElMessage.error("手机号填写错误")
  }
  if (!sendSms.value) {
    sendSms.value = true
    return;
  }
  sendSms.value = false
  loading.value = true
  let pay_params = JSON.stringify(props.type.login === 'xm_air' ? {
    access_token: props.account.access_token,
    user_id: props.account.user_id
  } : {cust_id: props.account.cust_id})
  new axiosApi({
    method: "coupon/pay",
    encode: "site",
    body: {
      coupon_id: product.value.id,
      uid: props.account.uid,
      pay_type: props.type.login,
      pay_params,
      number: num.value,
      auto_coupon: "1",
      mobile: mobile.value,
      order_from: order_from.value
    }
  }).send(res => {
    loading.value = false
    if (res.message.code !== "000" && res.message.code !== "7041") {
      return ElMessage.error(res.message.content)
    } else if (res.message.code === "7041") {
      realname.value = true
      return
    }
    if (props.type.login !== 'xm_air')
      router.push({name: 'success', params: {order: res.data.ordersn}})
    else window.location.replace(res.data.url)
  }, () => {
    loading.value = false
    ElMessage.error("兑换失败")
  })
}
const maxNum = computed(() => {
  if (Object.keys(props.account).length < 1) return 1;
  return Math.floor(parseFloat(props?.account?.balance_miles) / parseFloat(coupon.value?.[0]?.score_data?.[props.type.login]?.total))
})
</script>

<template>
  <div class="atl-product-box">
    <div class="atl-product-title">
      <el-image src="https://images.jifen360.com/atl/recharge.png"/>
    </div>
    <div class="atl-product-items">
      <div class="atl-product-item" v-for="(item,index) in coupon" :key="index">
        <div class="atl-product-item-prices">
          <div class="atl-product-item-prices-money">
            <b class="atl-product-unit">￥</b>
            <b>{{ parseFloat(item.face_value) }}</b>
          </div>
          <div class="atl-product-logo">
            <el-image src="https://images.jifen360.com/atl/logo.png"/>
          </div>
        </div>
        <div class="atl-product-item-content">
          <b class="atl-product-item-content-title">{{ item.name }}</b>
          <div class="atl-product-item-content-btn">
            <div class="atl-product-item-content-btn-left">
              <el-text :type="type?.login === 'xm_air'?'primary':'danger'" style="font-size: 1.3rem">
                {{ item?.score_data?.[type?.login]?.total }}
              </el-text>
              <el-text type="info" class="atl-product-unit" size="small">
                {{ item?.score_data?.[type?.login]?.unit }}
              </el-text>
            </div>
            <div class="atl-product-item-content-btn-right">
              <el-button round v-if="Object.keys(account).length < 1"
                         @click="product = item,emit('login')">
                立即兑换
              </el-button>
              <el-button round
                         v-else-if="account && account.balance_miles >= parseInt(item?.score_data?.[type.login]?.total)"
                         @click="product=item,showPayLoading=true">
                立即兑换
              </el-button>
              <el-button round v-else>可用{{ item?.score_data?.[type.login]?.unit }}不足</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="atl-recharge-box">
    <div class="atl-recharge-toolbar">
      <div class="atl-recharge-toolbar-info" @click="rechargeTool='01'"></div>
      <div class="atl-recharge-toolbar-info" @click="rechargeTool='02'"></div>
      <el-image :src="`https://images.jifen360.com/atl/${rechargeTool}.png`" class="atl-recharge-img"/>
    </div>
    <div class="atl-recharge-content">
      <div class="atl-recharge-content-article" v-if="rechargeTool  === '01'">
        <ol>
          <li>
            里程兑换代金券不提供报销凭证，兑换成功不可退换、转售、兑现、找零、拆分使用；
          </li>
          <li>
            本券兑换成功后，“电子代金券”以短信的形式发送至兑换时填写的手机号，
            <el-text type="danger" size="small">请确保兑换时手机号填写正确</el-text>
            ，因手机号码填写错误造成的损失由会员本人承担；
          </li>
          <li>
            本券有效期：短信获取的“电子代金券”需
            <el-text type="danger" size="small">60天内</el-text>
            在“奥特乐”微信小程序内完成绑定，绑定后三年有效。请在有效期内完成绑定及使用，过期作废，不退不补；
          </li>
          <li>
            “电子代金券”通过“奥特乐”小程序绑定，支持绑定前转赠；
          </li>
          <li>
            如需帮助，请拨打服务热线：4000-360-195。
          </li>
        </ol>
        <h4>
          使用方法
        </h4>
        <ol>
          <li>
            绑卡方法：“电子代金券”含卡号及密码，请点开短信内链接复制“卡号及密码” →微信搜索“奥特乐”
            小程序→点击【购物卡】→绑卡→输入卡号+密码→点击【合并】即为绑定成功；
          </li>
          <li>
            消费使用：绑定成功后，打开“奥特乐”微信小程序，点击“会员码”至收银台完成支付；
          </li>
          <li>
            绑卡后使用规则：
            <p>
              ·仅支持奥特乐线下门店购物使用，门店已覆盖区域：四川、重庆、陕西、贵州、云南，详情请至“奥特乐”微信小程序内查看。备注：不可用门店【奥特乐麓湖生态城plus店、成都金牛沙湾印象汇plus店】。
            </p>
            <p>
              ·无门槛、全场通用，可绑定多张卡合并使用。
            </p>
            <p>
              ·不记名，不挂失（遗失不补），不转售，不提供兑付或找零。如支付时消费金额超出卡内余额，超出支付部分另行支付，另行支付部分，支持提供报销凭证。
            </p>
            <p>
              ·使用时请遵守《奥特乐购物卡章程》。
            </p>
          </li>
          <li>
            本平台仅是提供会员与商户的兑换服务平台，如遇商品质量问题，请及时与商家联系。
          </li>
        </ol>
      </div>
      <div class="atl-recharge-content-step" v-if="rechargeTool  === '02'">
        <el-image src="https://images.jifen360.com/atl/recharge-step.png"/>
      </div>
    </div>
  </div>
  <el-drawer direction="btt" v-model="showPayLoading" :with-header="false" class="product-drawer" size="480"
             @closed="product={},mobile='',num=1" style="background-color: #FAFAFA">
    <div class="atl-product-payment-title">
      <div class="atl-product-logo">
        <el-image src="https://images.jifen360.com/atl/logo.png"/>
      </div>
      <div class="atl-product-title">
        <h4>{{ product?.name }}</h4>
        <p>
          <el-text type="info" size="small">无门槛 全场通用</el-text>
        </p>
        <p>
          <el-text type="danger" style="font-size: 1.4rem">{{ product?.score_data?.[type.login]?.total }}</el-text>
          <el-text type="info" size="small">{{ product?.score_data?.[type.login]?.unit }}</el-text>
        </p>
      </div>
    </div>
    <div class="atl-product-tips">
      <el-text type="info" size="small">
        兑换成功后，奥特乐的卡号和密码将以短信的形式发放至下方
        <el-text type="danger" size="small">填写的手机号</el-text>
        ，因手机号填写错误造成的损失由会员本人承担。
      </el-text>
    </div>
    <el-card>
      <div class="atl-product-form">
        <div class="atl-product-form-label">
          收货手机号
        </div>
        <div class="atl-product-form-input">
          <el-input v-model="mobile" placeholder="请输入收货手机号"/>
        </div>
      </div>
    </el-card>
    <el-card>
      <div class="atl-product-form">
        <div class="atl-product-form-label">
          兑换数量
        </div>
        <div class="atl-product-form-input">
          <el-input-number v-model="num" :min="1" :max="maxNum"/>
        </div>
      </div>
    </el-card>
    <el-card>
      <div class="atl-product-form">
        <div class="atl-product-form-label">可用{{ product?.score_data?.[type.login]?.unit }}</div>
        <div class="atl-product-form-input">
          {{ account?.balance_miles || 0 }}
        </div>
      </div>
      <div class="atl-product-form">
        <div class="atl-product-form-label">支付{{ product?.score_data?.[type.login]?.unit }}</div>
        <div class="atl-product-form-input">
          {{ product?.score_data?.[type?.login]?.total * num || 0 }}
        </div>
      </div>
    </el-card>

    <div class="atl-pay-btn">
      <el-button round size="large" :loading="loading" @click="payment">立即兑换</el-button>
    </div>
  </el-drawer>
  <send-sms-components v-if="sendSms" :show="sendSms" @sends="payment" :login-account="account"/>
  <real-name :dialog="realname" v-if="realname"/>
</template>

<style scoped lang="less">
.atl-product-box {
  margin: 15px;
  border-radius: 12px;
  overflow: hidden;
  background: #ffffff;

  .atl-product-title {
    box-sizing: border-box;
    padding: 10px 0;
  }

  .atl-product-items {
    box-sizing: border-box;
    padding: 10px;
    margin-top: -10px;

    .atl-product-item {
      background: url("@/assets/images/atl/coupon.png") no-repeat;
      background-size: 100% 100%;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 10px;

      .atl-product-item-prices {
        flex-basis: 20%;
        width: 20%;
        margin-right: 10px;
        text-align: center;

        .atl-product-item-prices-money {
          font-size: 1.4rem;
          display: flex;
          justify-content: center;
          color: #fff;

          .atl-product-unit {
            font-size: .8rem;
          }
        }

        .atl-product-logo {
          margin-top: 10px;

          .el-image {
            width: 80%;
          }
        }
      }

      .atl-product-item-content {
        flex-basis: 80%;
        width: 80%;
        line-height: 1.7;
        padding: 0 10px;
        box-sizing: border-box;
        //渐变色
        //background: ;
        .el-button {
          --el-button-bg-color: #6127BE;
          --el-button-border-color: #6127BE;
          --el-button-outline-color: #6127BE;
          --el-button-active-color: #6127BE;
          --el-button-hover-link-text-color: #6127BE;
          --el-button-hover-bg-color: #6127BE;
          --el-button-hover-border-color: #6127BE;
          --el-button-active-bg-color: #6127BE;
          --el-button-active-border-color: #6127BE;
          color: #ffffff;
        }

        .atl-product-item-content-title {
          font-size: .85rem;
        }

        .atl-product-item-content-btn {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      }
    }
  }
}

.atl-recharge-box {
  margin: 15px;

  .atl-recharge-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;

    .atl-recharge-toolbar-info {
      height: 55px;
      flex-basis: 50%;
      width: 50%;
      position: relative;
      z-index: 9;
    }

    .atl-recharge-img {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 0;
    }
  }

  .atl-recharge-content {
    box-sizing: border-box;
    padding: 15px;
    background: #ffffff;
    text-align: justify-all;
    margin-top: -5px;
    line-height: 1.75;
    border-radius: 0 0 12px 12px;

    ol {
      padding-left: 15px;
      font-size: .8rem;
    }
  }

  .atl-recharge-content-step {
    box-sizing: border-box;
    //padding: 15px;
    .el-image {
      box-sizing: border-box;
      padding: 15px;
      border-radius: 8px;
      background: #ECE9F5;
    }
  }
}

.product-drawer {
  .atl-product-payment-title {
    display: flex;
    align-items: stretch;

    .atl-product-logo {
      flex-basis: 100px;
      width: 100px;
      margin-right: 10px;
      background: #7763AA;
      border-radius: 8px;
      position: relative;

      .el-image {
        box-sizing: border-box;
        width: 75%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .atl-product-title {
      line-height: 1.45;
    }
  }

  .atl-product-tips {
    margin: 15px 0;
    line-height: 1.4;
  }

  .el-card {
    --el-card-border-radius: 12px;
    margin-bottom: 15px;

    .atl-product-form {
      display: flex;
      align-items: center;
      justify-content: space-between;
      --el-fill-color-blank: #F5F5F5;

      .atl-product-form-label {
        font-size: .8rem;
        flex-basis: 100px;
      }

      .atl-product-form-input {
        flex-basis: calc(100% - 100px);
        width: calc(100% - 100px);
        text-align: right;
      }

      & + .atl-product-form {
        margin-top: 10px;
        border-top: var(--el-border);
        padding-top: 10px;
      }
    }
  }

  .atl-pay-btn {
    .el-button {
      --el-button-bg-color: #7763AA;
      --el-button-border-color: #7763AA;
      --el-button-outline-color: #7763AA;
      --el-button-active-color: #7763AA;
      --el-button-hover-link-text-color: #7763AA;
      --el-button-hover-bg-color: #7763AA;
      --el-button-hover-border-color: #7763AA;
      --el-button-active-bg-color: #7763AA;
      --el-button-active-border-color: #7763AA;
      color: #ffffff;
      width: 100%;
    }
  }
}
</style>
